import React from 'react';
import '../template-file-css/document-file-template.css';



export const RRTS_Cans = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='RRTS_Cans' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><b>If client has been in service for a full year, they are is due for a full reassessment and treatment plan update, please schedule with LMHP completing Reassessments for the month ASAP. </b>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Client Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Client DOB:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtClientName' name='txtClientName' className='add-only' /> </td>
                        <td className='w-250'><input type='date' id='txtClientDob' name='txtClientDob' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinician contact#:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' />
                        </td>
                        <td className='w-375'> <input type='text' id='txtClinicianContact' name='txtClinicianContact' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>*Has he/she had thoughts of suicide/homicide? If so, any attempts?</span>
                    <textarea id="txtHasHeSheThoughtsSuicide" name="txtHasHeSheThoughtsSuicide" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Has he/she been violent towards others? If, yes please describe (give examples)</span>
                    <textarea id="txtHasSheViolentTowardsOther" name="txtHasSheViolentTowardsOther" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Has he/she run away? If yes, how recent and for how long were they gone. Provide details</span>
                    <textarea id="txtHasSheRanAway" name="txtHasSheRanAway" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Has he/she engaged in any inappropriate behaviors? If yes, explain the nature of inappropriate behaviors and how long they have persisted?</span>
                    <textarea id="txtHasSheEngagedInappropriateBehaviors" name="txtHasSheEngagedInappropriateBehaviors" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any concern for anxiety/depression? If yes, explain symptoms/behaviors to support in detail</span>
                    <textarea id="txtAnyConcernAnxietyDepressionExplainSymtoms" name="txtAnyConcernAnxietyDepressionExplainSymtoms" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any substance use? If yes, what substances are used and how frequently</span>
                    <textarea id="txtAnySubstanceUseIfYesWhatSubstance" name="txtAnySubstanceUseIfYesWhatSubstance" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any disclosed traumatic events? If yes, describe in detail</span>
                    <textarea id="txtAnyDisclosedTraumaticEventsDetailDescribe" name="txtAnyDisclosedTraumaticEventsDetailDescribe" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*How are his/her grades? Are they receiving any accommodations or are they contained in a behavioral unit? </span>
                    <textarea id="txtHowAreGradesReceivingAccomodationContained" name="txtHowAreGradesReceivingAccomodationContained" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any concerns at school? (Concerns from teachers? Are there frequent calls home in regards to behaviors?)</span>
                    <textarea id="txtAnyConcernSchoolTeacher" name="txtAnyConcernSchoolTeacher" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any arrests/legal issues? If yes, what were they arrested for? Has CPS been involved and for what reasons?</span>
                    <textarea id="txtAnyArrestLegalIssuesWhatArrestedCpsInvolved" name="txtAnyArrestLegalIssuesWhatArrestedCpsInvolved" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any hospitalizations? (medical or psychiatric)</span>
                    <textarea id="txtAnyHospitalizations" name="txtAnyHospitalizations" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any change in caregiver? If yes, when did this change occur and who is the new guardian? Are they willing to continue services?</span>
                    <textarea id="txtAnyChangesCaregiverChangeOccur" name="txtAnyChangesCaregiverChangeOccur" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any concerns from caregiver? If yes, detail in full.</span>
                    <textarea id="txtAnyConcernsCaregiverDetail" name="txtAnyConcernsCaregiverDetail" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*Any hallucinations or delusions? If yes, how recent? Describe events</span>
                    <textarea id="txtAnyHallucinationDelusions" name="txtAnyHallucinationDelusions" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>*How well does the client and family participate in services? Give details.</span>
                    <textarea id="txtHowWellDoesClientFamilyParticipateServices" name="txtHowWellDoesClientFamilyParticipateServices" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any other concerns/comments</span>
                    <textarea id="txtAnyOtherConcernsComments" name="txtAnyOtherConcernsComments" className='add-only'></textarea>
                </p>    



            </div>
        </form>

    )
}  
